import React from "react";
import "./Heading.css";

export default function Heading({ MainHeader }) {
  return (
    <div className="Heading">
      <h1>{MainHeader}</h1>
    </div>
  );
}
